import gql from 'graphql-tag';

export const adminAddHoursEntryIfNotExistMutation = gql`
  mutation adminAddHoursEntryIfNotExist(
    $userId: String!
    $payload: HoursEntryInput!
    $filter: HoursEntryFilter
  ) {
    adminAddHoursEntryIfNotExist(userId: $userId, payload: $payload) {
      id
      hoursEntries(filter: $filter) {
        id
        date
        timeFrom
        hours
        type
        activity
        category {
          id
          name
        }
        project {
          id
          name
          mandatoryCategory
        }
        issue {
          id
          ticketId
          title
        }
        description
        homeOffice
        workCategory {
          id
          name
          isActive
          isDefault
          description
          color
        }
        createdAt
      }
      dailyBalance {
        total
        done
        balance
      }
      weeklyBalance(filter: $filter) {
        total
        done
        balance
      }
      monthlyBalance(filter: $filter) {
        total
        done
        balance
      }
      totalBalance(filter: $filter) {
        total
        done
        balance
      }
      vacationBalance(filter: $filter) {
        total
        done
        balance
      }
    }
  }
`;

export const adminAddHoursEntryMutation = gql`
  mutation adminAddHoursEntry(
    $userId: String!
    $payload: HoursEntryInput!
    $filter: HoursEntryFilter
  ) {
    adminAddHoursEntry(userId: $userId, payload: $payload) {
      id
      hoursEntries(filter: $filter) {
        id
        date
        timeFrom
        hours
        type
        activity
        homeOffice
        workCategory {
          id
          name
          isActive
          isDefault
          description
          color
        }
        category {
          id
          name
        }
        project {
          id
          name
          mandatoryCategory
        }
        issue {
          id
          ticketId
          title
        }
        description
        createdAt
      }
      dailyBalance {
        total
        done
        balance
      }
      weeklyBalance(filter: $filter) {
        total
        done
        balance
      }
      monthlyBalance(filter: $filter) {
        total
        done
        balance
      }
      totalBalance(filter: $filter) {
        total
        done
        balance
      }
      vacationBalance(filter: $filter) {
        total
        done
        balance
      }
    }
  }
`;
